;(function () {
    function FilterResetButton(resetButton) {
        /**
         * local object availability
         * @type {navigation}
         * @private
         */
        var _this = this

        /**
         * Reset all buckets and the input box and submit the empty form to reset
         *
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            var form = $('[rel="search-filters"]').find('form')

            var bucketCheckboxes = $('[rel="search-filters--bucket"]').find('input').toArray()

            var input = $('[rel="search-filters--input-group"]').find('input')

            $(resetButton).click(function () {
                bucketCheckboxes.forEach(function (bucketCheckbox) {
                    bucketCheckbox.checked = false
                    $(input).val('')
                })
                form.submit()
            })
        }

        /**
         * initialize call navigation
         */
        _this.init()
    }

    window.FilterResetButton = window.FilterResetButton || {}

    window.FilterResetButton.FilterResetButton = FilterResetButton
})()

$(document).ready(function () {
    var resetButton = $('[rel="search-filters--reset-button"]')

    if (resetButton) {
        new window.FilterResetButton.FilterResetButton(resetButton)
    }
})
